import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Singleton coordinator for the "Report a bug" drawer's open/close state.
 * A trimmed clone of `GableDrawerService`'s open/close API — the report-bug
 * button toggles it and the drawer host subscribes to `isOpen$` (with OnPush
 * markForCheck) to render.
 */
@Injectable({ providedIn: 'root' })
export class BugReportDrawerService {
    private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
    readonly isOpen$: Observable<boolean> = this._isOpen$.asObservable();

    open(): void {
        if (!this._isOpen$.value) {
            this._isOpen$.next(true);
        }
    }

    close(): void {
        if (this._isOpen$.value) {
            this._isOpen$.next(false);
        }
    }

    toggle(): void {
        this._isOpen$.next(!this._isOpen$.value);
    }

    get isOpen(): boolean {
        return this._isOpen$.value;
    }
}
